/**
 * Whether this business has Flashkut. Flashkut's shelf ("Made in Flashkut") and "Make a room from this" show only
 * when it does; otherwise every upload is a plain upload and Flashkut is never named. Flashsuite knows which apps a
 * business has: the same answer its menu reads.
 */
import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

interface MenuState {
  apps?: { id: string; state: string }[];
}

const asked = new Map<string, Promise<boolean>>();

/** Ask Flashsuite once per business and page load. Any failure reads as no Flashkut: the plain upload is safe. */
function hasFlashkut(flashsuiteUrl: string, app: string, business: string): Promise<boolean> {
  const key = `${flashsuiteUrl}|${business}`;
  let got = asked.get(key);
  if (!got) {
    const url = `${flashsuiteUrl.replace(/\/+$/, "")}/menu/state?app=${encodeURIComponent(app)}&business=${encodeURIComponent(business)}`;
    got = fetch(url, { credentials: "include" })
      .then((res) => (res.ok ? (res.json() as Promise<MenuState>) : null))
      .then((s) => !!s?.apps?.some((a) => a.id === "flashkut" && a.state === "open"))
      .catch(() => false);
    asked.set(key, got);
  }
  return got;
}

export function useFlashkutAccount(): boolean {
  const { flashsuite, user } = useAuth();
  const [yes, setYes] = useState(false);
  useEffect(() => {
    if (!flashsuite || !user?.business_id) return;
    let live = true;
    void hasFlashkut(flashsuite.url, flashsuite.app, user.business_id).then((v) => {
      if (live) setYes(v);
    });
    return () => {
      live = false;
    };
  }, [flashsuite, user?.business_id]);
  return yes;
}

